"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureStat = void 0;
class AdventureStat {
    constructor(data) {
        this.name = data.name;
        this.description = data.description;
    }
    hasDescription() {
        return !!this.description;
    }
    toJSON() {
        return {
            name: this.name,
            description: this.description
        };
    }
}
exports.AdventureStat = AdventureStat;
//# sourceMappingURL=AdventureStat.js.map